import styled from "@emotion/styled";

const ArrowLeft = styled.svg<{ pointer?: boolean }>`
  cursor: ${({ pointer }) => (pointer ? "pointer" : "default")};
`;

export const Styled = {
  ArrowLeft,
};
